import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { SettingsProvider } from "@/context/SettingsContext";

import Layout from "@/components/public/Layout";
import AuthCallback from "@/components/AuthCallback";

import Home from "@/pages/public/Home";
import OurCoffee from "@/pages/public/OurCoffee";
import AvailableStock from "@/pages/public/AvailableStock";
import ProductDetail from "@/pages/public/ProductDetail";
import CoffeeOrigin from "@/pages/public/CoffeeOrigin";
import Quality from "@/pages/public/Quality";
import ExportLogistics from "@/pages/public/ExportLogistics";
import Warehouse from "@/pages/public/Warehouse";
import ExportJourney from "@/pages/public/ExportJourney";
import Gallery from "@/pages/public/Gallery";
import About from "@/pages/public/About";
import RequestQuote from "@/pages/public/RequestQuote";
import Contact from "@/pages/public/Contact";

import AdminLogin from "@/pages/admin/AdminLogin";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";
import { RouteSeo } from "@/components/Seo";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminInventory from "@/pages/admin/AdminInventory";
import AdminRFQ from "@/pages/admin/AdminRFQ";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminWarehouse from "@/pages/admin/AdminWarehouse";
import AdminExportJourney from "@/pages/admin/AdminExportJourney";
import AdminOrigins from "@/pages/admin/AdminOrigins";
import AdminStatistics from "@/pages/admin/AdminStatistics";
import AdminCompany from "@/pages/admin/AdminCompany";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LangProvider>
          <SettingsProvider>
            <BrowserRouter>
              <Toaster position="top-right" richColors />
              <RouteSeo />
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/our-coffee" element={<OurCoffee />} />
                  <Route path="/available-stock" element={<AvailableStock />} />
                  <Route path="/product/:slug" element={<ProductDetail />} />
                  <Route path="/coffee-origin" element={<CoffeeOrigin />} />
                  <Route path="/quality" element={<Quality />} />
                  <Route path="/export-logistics" element={<ExportLogistics />} />
                  <Route path="/our-warehouse" element={<Warehouse />} />
                  <Route path="/export-journey" element={<ExportJourney />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/request-quote" element={<RequestQuote />} />
                  <Route path="/contact" element={<Contact />} />
                </Route>

                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                  <Route path="dashboard" element={<AdminDashboard />} />
                  <Route path="inventory" element={<AdminInventory />} />
                  <Route path="rfq" element={<AdminRFQ />} />
                  <Route path="gallery" element={<AdminGallery />} />
                  <Route path="warehouse" element={<AdminWarehouse />} />
                  <Route path="export-journey" element={<AdminExportJourney />} />
                  <Route path="origins" element={<AdminOrigins />} />
                  <Route path="statistics" element={<AdminStatistics />} />
                  <Route path="company" element={<AdminCompany />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </SettingsProvider>
        </LangProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
